// function Products() {
//   return (
//     <div className="container" style={{ padding: "60px 0" }}>
//       <h1>Products</h1>
//     </div>
//   );
// }

// export default Products;






import ppe from "../images/products/ppe.webp";
import fasteners from "../images/products/fasteners.webp";
import tools from "../images/products/tools.webp";
import painting from "../images/products/painting.webp";
import abrasives from "../images/products/abrasives.webp";
import oilfield from "../images/products/oil-fitting.webp";
import packing from "../images/products/packing-material.jpg";
import React from "react";
import "../styles/products-page.css";

const productList = [
  {
    title: "Personal Protective Equipment (PPE)",
    description:
      "Safety gear designed to protect individuals from workplace hazards, including helmets, gloves, masks, and protective footwear.",
    image: ppe,
    icon: "fa-shield"
  },
  {
    title: "Fasteners",
    description:
      "High-quality bolts, nuts, screws, washers, and rivets used in construction, manufacturing, and industrial assemblies.",
    image: fasteners,
    icon: "fa-cogs"
  },
  {
    title: "Industrial Tools",
    description:
      "Heavy-duty hand tools and power tools designed for manufacturing, construction, and maintenance applications.",
    image: tools,
    icon: "fa-wrench"
  },
  {
    title: "Painting Accessories",
    description:
      "Brushes, rollers, trays, and accessories for professional painting and finishing applications.",
    image: painting,
    icon: "fa-paint-brush"
  },
  {
    title: "Abrasives",
    description:
      "Grinding wheels, sandpapers, and cutting discs used for smoothing, polishing, and surface finishing.",
    image: abrasives,
    icon: "fa-circle-o-notch"
  },
  {
    title: "Oil Field Fittings",
    description:
      "High-pressure valves, connectors, and fittings designed for oil and gas industry applications.",
    image: oilfield,
    icon: "fa-industry"
  },
  {
    title: "Packing Materials",
    description:
      "Durable packaging materials including tapes, wraps, and cushioning solutions for safe transport.",
    image: packing,
    icon: "fa-dropbox"
  }
];

function Products() {
  return (
    <>
      {/* PAGE HERO */}
      <section className="products-hero">
        <div className="container">
          <h1>Our Products</h1>
          <p>
            Supplying a comprehensive range of industrial products designed to
            meet diverse operational requirements.
          </p>
        </div>
      </section>

      {/* PRODUCTS LIST */}
      <section className="products-page">
        <div className="container">
          {productList.map((item, index) => (
            <div key={index} className="product-row">
              
              {/* IMAGE */}
              <div
                className="product-row-image"
                style={{ backgroundImage: `url(${item.image})` }}
              ></div>

              {/* CONTENT */}
              <div className="product-row-content">
                <span className="product-category-icon">
                  <i className={`fa ${item.icon}`}></i>
                </span>

                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <a href="/contact" className="btn btn-primary">
                  Send Inquiry
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Products;
